var map = {
	"./404-illustration.png": 1077,
	"./FAQ_link.png": 1078,
	"./LQDDemo/demo_skip.svg": 1079,
	"./LQDDemo/demo_thumb_course-1.png": 1080,
	"./LQDDemo/demo_thumb_course-2.png": 1081,
	"./LQDDemo/demo_thumb_course.png": 1082,
	"./LQDXp/XP_level_banner.svg": 1083,
	"./Logo_SparxMaths_Generic.png": 1084,
	"./Logo_SparxMaths_Generic@2x.png": 1085,
	"./Logo_SparxMaths_Homework.png": 1086,
	"./Logo_SparxMaths_Homework@2x.png": 1087,
	"./Logo_SparxMaths_Lesson.png": 1088,
	"./Logo_SparxMaths_Lesson@2x.png": 1089,
	"./accordion_arrow_closed.png": 1090,
	"./accordion_arrow_closed@2x.png": 1091,
	"./activity_icon_music.png": 1092,
	"./activity_icon_music@2x.png": 1093,
	"./activity_icon_xp.png": 1094,
	"./activity_icon_xp@2x.png": 1095,
	"./alert_update.png": 376,
	"./alert_update@2x.png": 377,
	"./answer_correct.png": 1096,
	"./answer_correct@2x.png": 1097,
	"./answer_handsup.png": 1098,
	"./answer_handsup@2x.png": 1099,
	"./answer_incorrect.png": 1100,
	"./answer_incorrect@2x.png": 1101,
	"./award_arrow.png": 1102,
	"./award_arrow@2x.png": 1103,
	"./award_current.png": 1104,
	"./award_current@2x.png": 1105,
	"./award_popover_icon_available.png": 1106,
	"./award_popover_icon_available@2x.png": 1107,
	"./award_popover_icon_unavailable.png": 1108,
	"./award_popover_icon_unavailable@2x.png": 1109,
	"./award_sparx_level.png": 1110,
	"./award_sparx_level@2x.png": 1111,
	"./award_unavailable_v2.png": 1112,
	"./award_unavailable_v2@2x.png": 1113,
	"./back_arrow.png": 1114,
	"./back_arrow@2x.png": 1115,
	"./background_black30.png": 1116,
	"./background_blue30.png": 1117,
	"./background_blue45.png": 1118,
	"./background_white25.png": 1119,
	"./background_white45.png": 1120,
	"./banner_level_background_radial.png": 1121,
	"./banner_level_background_radial@2x.png": 1122,
	"./banner_level_background_without_radial.png": 1123,
	"./bg_summary_unit_complete.svg": 1124,
	"./blue_spin.svg": 1125,
	"./browser-chevron.png": 1126,
	"./button_keypad_landscape.png": 1127,
	"./bw-check-illustration.svg": 378,
	"./calculator_allowed_scaled.svg": 1128,
	"./calculator_notallowed_scaled.svg": 1129,
	"./chevron_down_blue.png": 1130,
	"./chevron_down_blue@2x.png": 1131,
	"./chevron_down_grey.png": 1132,
	"./chevron_down_grey@2x.png": 1133,
	"./chrome-horizontal.png": 1134,
	"./close_popover.png": 1135,
	"./close_popover@2x.png": 1136,
	"./content_scroll_down.png": 1137,
	"./content_scroll_up.png": 1138,
	"./correct_fire.svg": 1139,
	"./correct_rebrand.svg": 1140,
	"./cross_icon.svg": 1141,
	"./cross_red.png": 1142,
	"./cross_red_circle.png": 1143,
	"./cross_red_circle@2x.png": 1144,
	"./cross_red_sm.png": 1145,
	"./current_level_modal.png": 1146,
	"./current_level_modal@2x.png": 1147,
	"./date.png": 1148,
	"./discovery/owned-badge.png": 1149,
	"./edge-horizontal.png": 1150,
	"./email-subscribe-cross.png": 1151,
	"./email-subscribe-cross@2x.png": 1152,
	"./email-subscribe-tick.png": 1153,
	"./email-subscribe-tick@2x.png": 1154,
	"./faq-completed-homework.png": 1155,
	"./firefox-horizontal.png": 1156,
	"./game-screenshots/100club-square.png": 1157,
	"./game-screenshots/100club.png": 1158,
	"./game-screenshots/blocksgame.png": 1159,
	"./game-screenshots/chantandlearn-square.png": 1160,
	"./game-screenshots/compound_questions_thumb.png": 1161,
	"./game-screenshots/dicegame.png": 1162,
	"./game-screenshots/egg_baskets_thumb.png": 1163,
	"./game-screenshots/find_it_tables_thumb.png": 1164,
	"./game-screenshots/garden_game_thumb.png": 1165,
	"./game-screenshots/gemsmash-square.png": 1166,
	"./game-screenshots/gemsmash.png": 1167,
	"./game-screenshots/grid_path_game_thumb.png": 1168,
	"./game-screenshots/marble_smasher_thumb.png": 1169,
	"./game-screenshots/minigameautohilo.png": 1170,
	"./game-screenshots/minigamefindit.png": 1171,
	"./game-screenshots/minigamehilo.png": 1172,
	"./game-screenshots/missing_phoneme_thumb.png": 1173,
	"./game-screenshots/pebbles.png": 1174,
	"./game-screenshots/peg_grid_thumb.png": 1175,
	"./game-screenshots/pictureshuffle-square.png": 1176,
	"./game-screenshots/pictureshuffle.png": 1177,
	"./game-screenshots/rhythm_game_thumb.png": 1178,
	"./game-screenshots/slidetables-square.png": 1179,
	"./game-screenshots/stickercollector-square.png": 1180,
	"./game-screenshots/stickercollector.png": 1181,
	"./game-screenshots/table_topper_thumb.png": 1182,
	"./game-screenshots/talk_to_me_thumb.png": 1183,
	"./game-screenshots/type_your_targets_thumb.png": 1184,
	"./game-screenshots/word_for_picture_thumb.png": 1185,
	"./game-select-menu/circle-512-blur.svg": 1186,
	"./game-select-menu/circle-512-padded.svg": 1187,
	"./game-select-menu/circle-512.svg": 1188,
	"./game-select-menu/coinstack-large.png": 1189,
	"./game-select-menu/dotted-chip-circle.svg": 1190,
	"./game-select-menu/homework-complete-tick.svg": 1191,
	"./game-select-menu/question-mark-circle.svg": 1192,
	"./help_flag.png": 1193,
	"./hilo/arrow.png": 1194,
	"./hilo/flare.png": 1195,
	"./hilo/heart.png": 1196,
	"./hilo/heart_light.png": 1197,
	"./hilo/tick.png": 1198,
	"./hilo/wheel_gradient.png": 1199,
	"./icon-arrow-left.svg": 1200,
	"./icon-arrow-right.svg": 1201,
	"./icon-challenge.svg": 1202,
	"./icon-chevron-left-blue.svg": 379,
	"./icon-core.svg": 1203,
	"./icon-extension.svg": 1204,
	"./icon-info.svg": 1205,
	"./icon-second-chance.svg": 1206,
	"./icon_azure.png": 380,
	"./icon_google.png": 381,
	"./icon_question_mark.svg": 1207,
	"./icon_see-teacher_lg.png": 1208,
	"./icon_user.png": 1209,
	"./icon_watch_video_blue.svg": 1210,
	"./icon_watch_video_white.svg": 1211,
	"./illustration_seek_help.png": 1212,
	"./keypad_back.png": 1213,
	"./keypad_back@2x.png": 1214,
	"./maintenance.png": 1215,
	"./menu_faqs.png": 1216,
	"./menu_faqs@2x.png": 1217,
	"./menu_faqs_hover.png": 1218,
	"./menu_faqs_hover@2x.png": 1219,
	"./menu_home.png": 1220,
	"./menu_home@2x.png": 1221,
	"./menu_home_hover.png": 1222,
	"./menu_home_hover@2x.png": 1223,
	"./menu_insights.png": 1224,
	"./menu_insights_hover.png": 1225,
	"./menu_logout.png": 1226,
	"./menu_logout@2x.png": 1227,
	"./menu_logout_hover.png": 1228,
	"./menu_logout_hover@2x.png": 1229,
	"./menu_rewards.png": 1230,
	"./menu_rewards@2x.png": 1231,
	"./menu_rewards_hover.png": 1232,
	"./menu_rewards_hover@2x.png": 1233,
	"./menu_user.png": 1234,
	"./menu_user@2x.png": 1235,
	"./menu_user_hover.png": 1236,
	"./menu_user_hover@2x.png": 1237,
	"./notifications/icon_bell.svg": 1238,
	"./notifications/icon_bouncing.svg": 1239,
	"./notifications/icon_early.svg": 1240,
	"./notifications/notification_bell.svg": 1241,
	"./notifications/notification_bell_on.svg": 1242,
	"./notifications/notification_new.svg": 1243,
	"./ordered_slot_link_h.png": 1244,
	"./padlock_game.png": 1245,
	"./padlock_game@2x.png": 1246,
	"./paper_grid.png": 1247,
	"./parent_accordion.svg": 1248,
	"./parent_back.svg": 1249,
	"./parent_chevron.svg": 1250,
	"./parent_faq_arrow.svg": 1251,
	"./parent_login.svg": 1252,
	"./parent_logo.svg": 1253,
	"./parent_notstarted_empty.png": 1254,
	"./parent_q.svg": 1255,
	"./parent_thumb.svg": 1256,
	"./parent_tips.svg": 1257,
	"./paused_headphones_off.png": 1258,
	"./paused_headphones_off@2x.png": 1259,
	"./paused_look_up.png": 1260,
	"./paused_look_up@2x.png": 1261,
	"./products/sparx_maths_blue_logo.svg": 382,
	"./products/sparx_maths_logo.svg": 1262,
	"./products/sparx_quiz_logo.svg": 1263,
	"./products/sparx_reader_logo.svg": 1264,
	"./products/sparx_science_logo.svg": 1265,
	"./progress-icons/diamond_full.svg": 1266,
	"./progress-icons/diamond_half.svg": 1267,
	"./progress-icons/diamond_none.svg": 1268,
	"./progress-icons/diamond_started.svg": 1269,
	"./progress-icons/homework_seen.svg": 1270,
	"./progress-icons/star_full.svg": 1271,
	"./progress-icons/star_half.svg": 1272,
	"./progress-icons/star_none.svg": 1273,
	"./progress-icons/star_started.svg": 1274,
	"./progress-icons/tick_full.svg": 1275,
	"./progress-icons/tick_half.svg": 1276,
	"./progress-icons/tick_none.svg": 1277,
	"./progress-icons/tick_started.svg": 1278,
	"./purple_spin.svg": 1279,
	"./question_mark.png": 1280,
	"./radial-grad.png": 1281,
	"./ratings/rating_1.png": 1282,
	"./ratings/rating_1_selected.png": 1283,
	"./ratings/rating_2.png": 1284,
	"./ratings/rating_2_selected.png": 1285,
	"./ratings/rating_3.png": 1286,
	"./ratings/rating_3_selected copy.png": 1287,
	"./ratings/rating_3_selected.png": 1288,
	"./ratings/rating_4.png": 1289,
	"./ratings/rating_4_selected.png": 1290,
	"./ratings/rating_5.png": 1291,
	"./ratings/rating_5_selected.png": 1292,
	"./restyle_background_gradient.svg": 383,
	"./reward_locked.png": 375,
	"./reward_locked@2x.png": 1293,
	"./right-chevron-circle.svg": 1294,
	"./rotate_device.png": 1295,
	"./rotate_device@2x.png": 1296,
	"./scroll_down.png": 1297,
	"./scroll_down@2x.png": 1298,
	"./scroll_left.png": 1299,
	"./scroll_left@2x.png": 1300,
	"./scroll_right.png": 1301,
	"./scroll_right@2x.png": 1302,
	"./scroll_up.png": 1303,
	"./scroll_up@2x.png": 1304,
	"./seek_help_student.svg": 1305,
	"./sparx_logo.svg": 1306,
	"./spin.svg": 228,
	"./strand_badge_green.png": 1307,
	"./strand_badge_grey.png": 1308,
	"./strand_badge_orange.png": 1309,
	"./strand_icon_algebra.svg": 1310,
	"./strand_icon_calculus.svg": 1311,
	"./strand_icon_fundamentals_ratio_proportion.svg": 1312,
	"./strand_icon_geometry.svg": 1313,
	"./strand_icon_geometry_position_direction.svg": 1314,
	"./strand_icon_matrices.svg": 1315,
	"./strand_icon_measurement.svg": 1316,
	"./strand_icon_number.svg": 1317,
	"./strand_icon_number_fractions.svg": 1318,
	"./strand_icon_number_place_value.svg": 1319,
	"./strand_icon_probability.svg": 1320,
	"./strand_icon_ratioproportion.svg": 1321,
	"./strand_icon_statistics.svg": 1322,
	"./tables-chip-placeholder.png": 1323,
	"./task_cross.png": 1324,
	"./task_cross@2x.png": 1325,
	"./task_handsup.png": 1326,
	"./task_handsup@2x.png": 1327,
	"./task_help_flag.png": 1328,
	"./task_seek_help_student.svg": 1329,
	"./task_tick.png": 1330,
	"./task_tick@2x.png": 1331,
	"./task_tick_grey.png": 1332,
	"./task_tick_grey@2x.png": 1333,
	"./task_tick_white.png": 1334,
	"./task_tick_white@2x.png": 1335,
	"./tick-btn-complete.png": 1336,
	"./tick_green_circle.png": 1337,
	"./tick_green_circle@2x.png": 1338,
	"./tick_white.png": 1339,
	"./tokens/background_radial.png": 374,
	"./tokens/token_awarded_large.png": 373,
	"./tokens/token_awarded_medium.png": 1340,
	"./tokens/token_medium.png": 1341,
	"./tokens/token_small.png": 1342,
	"./topic_strength.png": 1343,
	"./topic_strength@2x.png": 1344,
	"./topic_weakness.png": 1345,
	"./topic_weakness@2x.png": 1346,
	"./training/icon-chevron-left-orange.svg": 1347,
	"./training/icon-chevron-left-white.svg": 1348,
	"./training/icon-chevron-right.svg": 1349,
	"./training/icon-dropdown-menu.svg": 1350,
	"./warning.png": 1351,
	"./well-done-banner.png": 1352,
	"./workbook.svg": 1353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1076;